import { ErrorCodeList } from '../enums/ErrorCodeList';
import RequestConfigurationFactoryInstance from './Request/RequestConfigurationFactory';

const logSnagError = ({ networkError, message, error, errorCode }: any) => {
  const errorMsgForTools =
    networkError ||
    message ||
    (typeof error === 'string' ? error : 'no error msg available');
  RequestConfigurationFactoryInstance.handleSnagUiError(errorMsgForTools, {
    code: errorCode,
    ...((!networkError || errorCode === 401) && {
      errorSource: 'dsrIgnoreSnag',
    }),
  });
};

export const handleApiError = (error: any) => {
  try {
    const [{ extensions: { code = '' } = {}, networkError, message = '' }] =
      Array.isArray(error) ? error : [error];

    const errorCode = code || networkError?.statusCode;
    logSnagError({ networkError, message, error, errorCode });

    // TODO: implement handle errors
    //  error.networkError.result.errors.message
    //  error.networkError.result.status
    //  error.networkError.statusCode
    //  window.location.reload();

    if (errorCode === ErrorCodeList.Unauthorized) {
      return window.location.reload();
    }
  } catch (e) {
    // do nothing, let the app handle it
  }
};
